import React from 'react';
import type {SxProps} from '@mui/material';
import {useTheme} from '@mui/material';
import type {IconName} from 'components/icons/types';
import type {ChangeRequestType} from 'services/metadata/types';
import {FlexBox, Icon} from 'components';

type Props = {
  type: ChangeRequestType;
};

export const ChangeRequestIcon: React.FC<Props> = ({type}) => {
  const {colors, status} = useTheme();
  const typeMap: Record<
    ChangeRequestType,
    {name: IconName; bgcolor: string; iconSx: SxProps}
  > = {
    ML_MANUAL_APPROVAL: {
      name: 'ML2',
      bgcolor: status.ml,
      iconSx: {color: colors.offWhite},
    },
    METADATA_NEW: {
      name: 'Download',
      bgcolor: status.ml,
      iconSx: {color: colors.offWhite},
    },
    METADATA_MOVED: {
      name: 'Swap',
      bgcolor: status.change,
      iconSx: {color: colors.burgundy},
    },
    METADATA_COPIED: {
      name: 'Copy',
      bgcolor: status.change,
      iconSx: {color: colors.burgundy},
    },
    METADATA_IMPORT_CHANGE: {
      name: 'Building',
      bgcolor: status.ml,
      iconSx: {color: colors.offWhite},
    },
  };

  return (
    <FlexBox
      center
      bgcolor={typeMap[type].bgcolor}
      p={0.25}
      sx={{borderRadius: 1}}>
      <Icon icon={typeMap[type].name} sx={typeMap[type].iconSx} />
    </FlexBox>
  );
};
